import { render, staticRenderFns } from "./depart_list.vue?vue&type=template&id=6d87a192&scoped=true&"
import script from "./depart_list.vue?vue&type=script&lang=js&"
export * from "./depart_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d87a192",
  null
  
)

export default component.exports